import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { AuthContext } from '../../contexts/AuthContext';

// Web-only, admin-only. UI gate only: the backend enforces template access itself.
export default function AdminRoute({ children }) {
  const { auth, loading, sessionReady } = useContext(AuthContext);
  if (Capacitor.isNativePlatform()) return <Navigate to="/dashboard" replace />;
  // AppShell mounts its own AuthProvider, which hydrates the session after first render;
  // deciding before then would bounce real admins.
  if (loading || !sessionReady) return null;
  if (!auth?.user?.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}
